export default __webpack_public_path__ + "static/media/rankpage-top1.75347b9b.svg";